// import styles bundle
import AnimationsOnScroll from "./AnimationsOnScroll";
import Animations from "./Animations";
import CustomSelect from "./Select";

import ajax from '@fdaciuk/ajax'
import "../css/style.scss"
import Pristine from 'pristinejs';
import Swip from "./modules/swiper"
const mainSw = new Swip()

const app = {

	selectProduct: () => {
		const formSections = document.querySelectorAll('.mainform__products'); // Assuming each section has this class
		const button = document.querySelector('.mainform--step2 .next-btn');
	
		formSections.forEach(form => {
			// Check if the form section exists and add an event listener for each section
			if (form) {
				form.addEventListener('change', function(event) {
					if (event.target.classList.contains('product-input')) {
						
						// Remove 'selected' class from all labels within this section
						form.querySelectorAll('.inputcont').forEach(label => {
							label.classList.remove('selected');
						});
						
						// Add 'selected' class to the clicked input's container
						if (event.target.checked) {
							event.target.closest('.inputcont').classList.add('selected');
						}
						
						// Activate the button
						if (button) {
							button.classList.add('active');
						}
					}
				});
			}
		});
	},
	

	pointslabel: (quantity) => {
		let r1 = quantity % 100;

		if (r1 === 1 && quantity < 100) {
			return 'punkt'; // Dla 1 produkt
		} else {
			let r2 = r1 % 10;
	
			if ((r2 > 1 && r2 < 5) && (r1 < 12 || r1 > 14)) {
				return 'punkty'; 
			} else {
				return 'punktów';
			}
		}
	},

	registerVali: () => {
		var form = document.querySelector('.woocommerce-form-register');
		
		if (form) {
			// Flag to indicate a programmatic form submission
			var isProgrammaticSubmit = false;
		  
			var config = {
			  classTo: 'woocommerce-form-row',
			  errorClass: 'woocommerce-form-row--error',
			  errorTextParent: 'woocommerce-form-row',
			  errorTextTag: 'div',
			  errorTextClass: 'visually-hidden'
			};
		  
			var pristine = new Pristine(form, config);
		  
			form.addEventListener('submit', function (e) {
				console.log('Form submission initiated.');
				if (!isProgrammaticSubmit) {
					e.preventDefault(); // Prevent form submission for manual validation
					var valid = pristine.validate();
					console.log('Is form valid?', valid);
					if (valid) {
						isProgrammaticSubmit = true; // Set the flag
						form.submit(); // Programmatically submit the form
						console.log('Form submitted programmatically.');
					}
				} else {
					console.log('Flag reset.');
					isProgrammaticSubmit = false;
				}
			});
		}
	},
	

	getValidationConfig: () => {

		Pristine.addValidator(
		    'equals',
		    function (val, otherFieldSelector) {
		        var other = document.querySelector(otherFieldSelector);
		        return other && ((!val && !other.value) || other.value === val);
		    },
		    'Fields do not match',
		    1,
		    true
		);

		let config = {
         	classTo: 'inputcont',
         	errorClass: 'inputcont--error',
         	successClass: 'inputcont--success',
			 errorTextParent: 'inputcont',
			 errorTextTag: 'div',
			 errorTextClass: 'inputcont--helpers' 
      	};

      	return config;

	},

	steps: () => {

		// Initial setup: hide all steps except the first one
		var steps = document.querySelectorAll('div[class^="mainform--step"]');
		for (var i = 1; i < steps.length; i++) {
			steps[i].style.display = 'none'; // Hide all steps except the first
		}
	
		// Function to go to the next step
		function goToNextStep(currentStep) {
			var nextStep = currentStep.nextElementSibling; // Find the next step
			if (nextStep && nextStep.matches('div[class^="mainform--step"]')) {
				currentStep.style.display = 'none'; // Hide current step
				nextStep.style.display = 'block'; // Show next step
				nextStep.scrollIntoView({
					behavior: 'smooth', 
					block: 'start'  
				});
			}
		}
	
		// Add click event listener to all buttons
		var btns = document.querySelectorAll('.next-btn');
		btns.forEach(function(btn) {
			btn.addEventListener('click', function(e) {
				e.preventDefault(); // Prevent the default form submission
				var currentStep = this.closest('div[class^="mainform--step"]');
				var form = document.querySelector('.main-form'); // Assuming there's a form element to target
	
				// Check if the clicked button has the class 'voucher-btn'
				if (this.classList.contains('voucher-btn')) {
					form.classList.add('voucher-order'); // Add the class to the form
				}
	
				// Proceed to the next step if the current step exists
				if (currentStep) {
					goToNextStep(currentStep);
				}
			});
		});
	},
	
	orderType: () => {
		const form = document.querySelector('.main-form');
		if (form) {
			const btnVoucher = document.querySelector('.voucher-btn');
			const orderType = form.querySelector('#form_type');
			
			if(btnVoucher) {
				btnVoucher.addEventListener('click', function() {
					orderType.value = 'voucher-order';
				});
			}

		}
	},


	inputsVali: () => {
		const inputContainers = document.querySelectorAll('.package-wrapper');
		const btns = document.querySelectorAll('.inputcont__btn');
	
		function checkUniqueValues() {
			const values = new Set(); 
			let isUnique = true;
	
			inputContainers.forEach(container => {
				const input = container.querySelector('.inputcont__text');
				const value = input.value.trim();
	
				if (value) { 
					if (values.has(value)) {
						alert('Numer paczki już został przez Ciebie użyty');
						isUnique = false;
						input.focus(); 
						return;
					} else {
						values.add(value);
					}
				}
			});
	
			return isUnique;
		}
	
		btns.forEach(btn => {
			btn.addEventListener('click', function() {
				const isUnique = checkUniqueValues();
				if (isUnique) {
					console.log('All values are unique.');
				}
			});
		});

	},


	newOrder: () => {

		let config = app.getValidationConfig();
		let forms = document.querySelectorAll('.mainform');
	
		if (forms) {
			[].forEach.call(forms, e => {
				let submitBtn = e.querySelector('.main-form__btn');
				let form = e.querySelector('.main-form');
	
				let formValidator = new Pristine(e, config, true);
	
				submitBtn.addEventListener('click', (e) => {
					e.preventDefault();
	
					if (formValidator.validate()) {
						let formData = new FormData(form);
						formData.append('action', 'ajax_order');
	
						let request = ajax({
							method: 'POST',
							headers: {
								'content-type': false
							},
							url: wpp.ajax,
							data: formData
						});
	
						request.then(function(response) {
							form.innerHTML = response.final_html;
							
							// Scroll to the final section after content update
							const finalSection = document.querySelector('.mainform--final'); // Change to the target element's selector
							if (finalSection) {
								finalSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
							}
						});
					}
				}, false);
			});
		}
	},


	packagesLogic: () => {

		let packages = document.querySelectorAll('.package-wrapper');
		let counter = document.querySelector('.points-number');
	
		let nextBtn = document.getElementById('first-step'); // Selecting by ID
		let pointsLabel = document.getElementById('points-label'); // Selecting by ID
	
		// Track number of packages successfully sent in the voucher column
		let voucherColumn = document.querySelector('.voucher-column');
		let voucherBtn = document.querySelector('.voucher-btn');
	
		let sentPackagesCount = 0;
		let voucherUnlocked = false; // Flaga, aby komunikat pokazał się tylko raz
	
		if (packages) {
	
			let timeout;
	
			[].forEach.call(packages, e => {
	
				let pristineError = e.querySelector('.pristine-error.inputcont--helpers');
				let btn = e.querySelector('.inputcont__btn');
				let input = e.querySelector('.inputcont__text');
	
				btn.addEventListener('click', () => {
					app.inputsVali();
					btn.classList.add('clicked');
					clearTimeout(timeout);
	
					// Set timeout - user may choose multiple options - fire after 1s
					timeout = setTimeout(() => {
	
						let filtersFormData = new FormData();
						// Append input name as key and input value as value
						filtersFormData.append(input.name, input.value);
						// Append the action you want to trigger on the server
						filtersFormData.append('action', 'ajax_check_package');
	
						let request = ajax({
							method: 'POST',
							headers: {
								'content-type': false
							},
							url: wpp.ajax,
							data: filtersFormData
						});
	
						request.then(function(response) {
							console.log("Response:", response); // Debug: sprawdź odpowiedź z serwera
							if (response.status == 'sent') {
								btn.classList.remove('clicked');
	
								// Successfully sent, mark the package
								e.classList.add("sent");
								e.dataset.value = '2';
								
								// Pobierz i przeanalizuj liczbę punktów
								let currentPoints = parseInt(counter.textContent, 10);
								let pointsToAdd = parseInt(response.value, 10); // Konwertuj punkty na liczbę
								
								// Sprawdzenie punktów, by upewnić się, że nie są NaN
								if (isNaN(pointsToAdd)) {
									console.error("Points to add is not a valid number:", response.value);
									pointsToAdd = 0; // Ustaw na 0, jeśli jest problem z wartością
								}
	
								let newPoints = currentPoints + pointsToAdd;
								counter.textContent = newPoints.toString();
								pointsLabel.textContent = app.pointslabel(newPoints);
	
								console.log("Current Points:", currentPoints); // Debug: aktualne punkty
								console.log("New Points:", newPoints); // Debug: nowe punkty po dodaniu
	
								// Check if the package is in the voucher column
								if (voucherColumn.contains(e) && !e.classList.contains('counted')) {
									sentPackagesCount++;
									e.classList.add('counted'); // Mark this package as counted
								}
	
								// If 3 packages have been sent in the voucher column and voucher not yet unlocked
								if (sentPackagesCount === 3 && !voucherUnlocked) {
									voucherUnlocked = true; // Ustaw flagę, aby komunikat pokazał się tylko raz
									voucherBtn.style.display = 'inline-block';
								}
	
								// Display the next button if points threshold met
								if (newPoints >= 10) {
									nextBtn.style.display = 'inline-block';
								}
	
							} else if (response.status == 'non-existent') {
								btn.classList.remove('clicked');
								pristineError.style.display = 'block';
								pristineError.innerHTML = response.msg;
								e.classList.remove('inputcont--success');
								e.classList.add('inputcont--error');
							}
						});
	
					}, 700);
	
				});
	
			});
	
		}
	
	},
	
	
	


	catFilters: () => {
		let form = document.querySelector('.shops-form');
	
		if (form) {
			let select = form.querySelector('select[name="category"]');
			let inputs = form.querySelectorAll('input');
			let textInput = form.querySelector('input[name="filter"]');
			let pageInput = form.querySelector('input[name="page"]'); // Obsługa paginacji
	
			let featuredWrapper = document.querySelector('.featured-wrapper');
			let restWrapper = document.querySelector('.rest-wrapper');
			let pagy = document.querySelector('.pagy-wrapper');

			let timeout;
	
			// Funkcja do obsługi zmian filtrów z opcjonalnym resetem `page`
			const handleFormChange = (resetPage = false) => {
				clearTimeout(timeout);
	
				timeout = setTimeout(() => {
					// Jeśli resetPage jest true, ustawiamy `page` na 1
					if (resetPage && pageInput) {
						pageInput.value = '1';
					}
	
					// Tworzenie FormData po ustawieniu `page` na '1'
					let filtersFormData = new FormData(form);
	
					let search = new URLSearchParams(filtersFormData);
					let queryString = search.toString();
					let base = form.getAttribute('data-base');
	
					if (window.history) {
						window.history.pushState("", "", base + '?' + queryString);
					}
	
					filtersFormData.append('action', form.getAttribute('data-action'));
	
					let request = ajax({
						method: 'POST',
						headers: {
							'content-type': false
						},
						url: wpp.ajax,
						data: filtersFormData
					});
	
					request.then(function(response) {
						featuredWrapper.innerHTML = response.featured_html;
						restWrapper.innerHTML = response.rest_html;

						pagy.innerHTML = response.pagy_html;
						app.shopsPagination(); // Ponowna inicjalizacja paginacji
					});
	
				}, 500);
			};
	
			// Listener dla select - resetujemy `page` do 1
			if (select) {
				select.addEventListener('change', () => {
					handleFormChange(true); // resetPage = true
				});
			}
	
			// Listener dla textInput - resetujemy `page` do 1
			if (textInput) {
				textInput.addEventListener('input', () => {
					handleFormChange(true); // resetPage = true
				});
			}
	
			// Listener dla pozostałych inputów - nie resetujemy `page`
			[].forEach.call(inputs, e => {
				if (e !== textInput) { // Tylko dla innych inputów, bez `textInput`
					e.addEventListener('change', () => handleFormChange(false));
				}
			});
		}
	},
	
	observer: () => {
		
		const step3Element = document.querySelector('.mainform--step3');

		if(step3Element) {

			function onVisibilityChange(mutationsList, observer) {
				for (const mutation of mutationsList) {
					if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
						// Check if the element is now visible
						if (window.getComputedStyle(step3Element).display !== 'none') {
							// Re-initialize the map
							SzybkaPaczkaMap.init({
								lang: 'PL',
								country_parcelshops: 'PL',
								el: 'gls_map',
								parcel_weight: '5',
								map_type: true,
								google_maps_key: 'AIzaSyC-0vVMIANAiA7bz7XbtnkKHQuw3JAzbmE',
								parcelshop_type: 'apm'
							});

							// Disconnect the observer if you only need this once
							observer.disconnect();
						}
					}
				}
			}

			// Create an observer instance
			const observer = new MutationObserver(onVisibilityChange);

			// Start observing for attribute changes
			observer.observe(step3Element, { attributes: true });
		}

	},
	
	showMobileMenu: () => {
		let mobileMenu = document.querySelector('.mobile-menu');
		let hamburger = document.querySelector('#opener');
	
		if (hamburger) {
			hamburger.addEventListener('click', () => {
				mobileMenu.classList.toggle('active');
				hamburger.classList.toggle('active');
				document.body.classList.toggle('body-no-scroll');
			});
	
			let links = mobileMenu.querySelectorAll('a');
			links.forEach(link => {
				link.addEventListener('click', () => {
					mobileMenu.classList.remove('active');
					hamburger.classList.remove('active');
					document.body.classList.remove('body-no-scroll');
				});
			});
		}
	},

	shopsPagination: () => {

		let pagination 	= document.querySelector('.pagination');

		if ( pagination ) {

			let input 		= document.querySelector('.pagination-page-input');

			if ( input ) {
				let current 	= parseInt(input.value);

				let pages 		= document.querySelectorAll('.pagination__page');
				let next 		= document.querySelector('[data-pagination-next]');
				let prev 		= document.querySelector('[data-pagination-prev]');

				if ( next ) {
					next.addEventListener('click', () => {
						input.value = current + 1;
						input.dispatchEvent(new Event('change'));
					});
				}

				if ( prev ) {
					prev.addEventListener('click', () => {
						input.value = current - 1;
						input.dispatchEvent(new Event('change'));
					});
				}

				[].forEach.call(pages, e => {

					e.addEventListener('click', () => {

						input.value = e.getAttribute('data-page');
						input.dispatchEvent(new Event('change'));

					});

				});
			}

		}

	},

	recomForm: () => {

		let forms 		= document.querySelectorAll('.send-shop');
	
		if ( forms ) {
	
		  [].forEach.call(forms, form => {

			let submitBtn   	= form.querySelector('.btn');
			let msg         	= form.querySelector('.cf-message');

	
			  submitBtn.addEventListener('click', (e) => {
				
				e.preventDefault();
		
				var formData = new FormData(form);
	
				formData.append('action', form.getAttribute('data-action'));
	
				let request = ajax({
				  method: 'POST',
				  headers: {
					  'content-type': false
				  },
				  url: wpp.ajax,
				  data: formData
				});
				request.then(function(response) {
					msg.classList.add('sent');
					let inputFields = form.querySelectorAll('input, textarea');
					[].forEach.call(inputFields, field => {
						field.value = '';
					});
				});
			   
	
			  }, false);
	
			});
		  }
	},


	/*updateLazyLoad: (images) => {
		var ll = new LazyLoad({

			callback_loaded: image => {
				if (image.classList.contains("lazy--bg")) {
					setTimeout(() => {
						const src = image.currentSrc || image.src;
						const parent = image.parentNode;

						if (!parent.classList.contains("loaded")) {
							parent.classList.add("loaded");
							parent.style.backgroundImage = `url(${src})`;
						}
					}, 10);
				}
			}

		},images);
	},
    */


    init: () => {

		AnimationsOnScroll.init();
		new CustomSelect('custom-select');
		app.catFilters();

		app.packagesLogic();
		app.inputsVali();
		app.newOrder();
		app.steps();
		app.getValidationConfig();
		app.selectProduct();
		app.observer();
		app.showMobileMenu();
		app.shopsPagination();
		app.recomForm();
		app.orderType();
	},

}


document.addEventListener("DOMContentLoaded", () => {
	app.init();

});
